var model3d = require("./model3d.js");
var lib_core = require("lib-core")

// this is NOT a proper DATA class.  It has no handlers. and it cannot be jsonified.
// This means If you try and change the obj or mtl properties, the geometry will not rebuild.
// It also cannot save.  It probably should not be in the datamodel module.
// I suggest not using this class for anything (else)
// TODO this should be cleaned up.  Either use the proper model class or take this out of the datamodel.
// if we want to make it an actual datamodel class we will need to impliment threejs's json save functionality
var Model3dDummyData = function(obj, mtl) {
    this.obj = obj;
    this.mtl = mtl;

    this.initModelHandlers();  // handlers won't work because explanation above
};

lib_core.mixin(Model3dDummyData, model3d);

module.exports = Model3dDummyData;

Model3dDummyData.prototype.calculateGeometryInfo = function(){
    var self = this;
    // this line needs to come first
    if(this.hasModelCache()){
         return new Promise(function(resolve){ resolve(  self.getModelCache() )});
    }

    return new Promise(function(resolve, reject){
        resolve( self.buildFromFiles(self.obj, self.mtl) );
    });
}